// extracted by mini-css-extract-plugin
export default {"mobileLeftAlignStyle":"Security_mobileLeftAlignStyle__BSYIW","topLine":"Security_topLine__jgCWa"};